import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, DatePicker, Modal } from 'antd';
import FileUpload from '../FileUpload';
import moment from 'moment';

interface IProps {
  addContractVisible: boolean;
  setAddContractVisible: (visible: boolean) => void;
  onSubmitContract: () => void;
  startDate: string;
  setStartDate: (date: string) => void;
  endDate: string;
  setEndDate: (date: string) => void;
  contractFile: File|null;
  setContractFile: (file: File|null) => void;
}

const AddContractModal: FC<IProps> = ({
  addContractVisible, setAddContractVisible, onSubmitContract,
  startDate, setStartDate, endDate, setEndDate,
  contractFile, setContractFile
}) => {
  const { t } = useTranslation();
  const onClose = () => {
    setStartDate('');
    setEndDate('');
    setContractFile(null);
    setAddContractVisible(false);
  }

  return (
    <Modal
      title={t('campus.staff.button3')}
      visible={addContractVisible}
      onCancel={onClose}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={onSubmitContract}
          >
            {t('campus.staff.button2')}
          </AntButton>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={onClose}
          >
            {t('common.button.cancel')}
          </AntButton>
        </div>
      ]}
    >
      <div className="form-group row">
        <div className="col-3 text-right v-line">{t('campus.staff.column7')}</div>
        <div className="date-picker__area">
          <div className="date">
            <DatePicker
              value={startDate ? moment(startDate) : undefined}
              onChange={e => {
                if (e === null) setStartDate('');
                else setStartDate(moment(e).format('YYYY-MM-DD'))
              }}
            />
          </div>
          <div>~</div>
          <div className="date">
            <DatePicker
              value={endDate ? moment(endDate) : undefined}
              onChange={e => {
                if (e === null) setEndDate('');
                else setEndDate(moment(e).format('YYYY-MM-DD'))
              }}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-3 text-right v-line">{t('campus.staff.column8')}</div>
        <div className="col-9 pl-0">
          <FileUpload
            file={contractFile}
            setFile={setContractFile}
          />
        </div>
      </div>
    </Modal>
  );
}

export default AddContractModal;
